export default __webpack_public_path__ + "static/media/sandero-gallery-8.94c0a469.jpg";